import React from 'react';
import { Select, Option } from '@fiverr-private/forms';
import { appTranslate } from '../../../../i18n';
import { useFiltersContext } from '../../../../context/FiltersContext';
import { FilterStatusEnum } from '../../../../context/FiltersContext/FilterContext.types';

export const SelectStatus = () => {
  const { appliedStatusFilter, updateStatusFilter } = useFiltersContext();

  const onChange = (selectedValue) => {
    const status = selectedValue?.item || null;
    updateStatusFilter(status);
  };

  return (
    <Select
      placeholder={appTranslate<string>('filters.status.title')}
      value={{ item: appliedStatusFilter || '' }}
      onChange={onChange}
    >
      <Option key={FilterStatusEnum.ACTIVE} value={FilterStatusEnum.ACTIVE}>
        {appTranslate<string>('filters.status.active')}
      </Option>
      <Option key={FilterStatusEnum.REMOVED} value={FilterStatusEnum.REMOVED}>
        {appTranslate<string>('filters.status.removed')}
      </Option>
    </Select>
  );
};
